import PromotionListContainer from './PromotionListContainer';
export default PromotionListContainer;
